import * as action from './floorAction'
import { default as actionType } from './floorActionType'
import { default as reducer } from './floorReducer'

export const FLOOR = {
  action,
  actionType,
  reducer
}
